import React from "react";

import { isAdmin } from "../../Utils/Auth";
import { AccountInfo } from "@azure/msal-browser";
import "./style.scss";

import ContainerCustomers from "./Customer/ContainerCustomers";
import { ICustomer } from "../../interfaces/ICustomer";
import ContainerProject from "./Project/ContainerProject";
import ContainerOpenQuote from "./OpenQuote/OpenQuote";
import ContainerRecentQuotes from "./RecentQuotes/ContainerRecentQuotes";
import ContainerLatestTimeBookings from "./LatestTimeBookings/ContainerLatestTimeBookings";
import ContainerTimesafeInfo from "./TimesafeInfo/ContainerTimesafeInfo";
import ContainerTsQuickBooking from "./TsQuickBooking/ContainerTsQuickBooking";

function HomeContainer(props: { account: AccountInfo | null; customers: ICustomer[] }) {
    let admin = isAdmin(props.account);

    return (
        <>
            <div className="container container--dashboard">
                {!admin && (
                    <div className="dashboard">
                        <ContainerTsQuickBooking classes="ds-width-3" />
                        <ContainerLatestTimeBookings classes="ds-width-5" />
                        <ContainerTimesafeInfo classes="ds-width-3" />
                    </div>
                )}
                {admin && (
                    <>
                        <div className="dashboard">
                            <ContainerCustomers classes="ds-width-3" customers={props.customers} />
                            <ContainerProject classes="ds-width-3" customers={props.customers}/>
                            <ContainerOpenQuote classes="ds-width-3"/>
                            <ContainerTsQuickBooking classes="ds-width-3" />
                            <ContainerRecentQuotes classes="ds-width-4" />
                            <ContainerLatestTimeBookings classes="ds-width-5" />
                            <ContainerTimesafeInfo classes="ds-width-3" />
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default HomeContainer;
